namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoApprovalTranDtDialog extends Serenity.Extensions.GridEditorDialog<PoApprovalTranRow> {
        // export class PoApprovalTranDialog extends  Serenity.EntityDialog<PoApprovalTranRow,any> {
       
        protected getFormKey() { return PoApprovalTranForm.formKey}
        // protected getIdProperty() { return PoApprovalTranRow.idProperty; }
        protected getLocalTextPrefix() { return PoApprovalTranRow.localTextPrefix; }
        protected getNameProperty() { return PoApprovalTranRow.nameProperty; }
        // protected getService() { return PoApprovalTranService.baseUrl; }
        // protected getDeletePermission() { return PoApprovalTranRow.deletePermission; }
        // protected getInsertPermission() { return PoApprovalTranRow.insertPermission; }
        // protected getUpdatePermission() { return PoApprovalTranRow.updatePermission; }

        protected form = new PoApprovalTranForm(this.idPrefix);
        
       

        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

                let Approve: Serenity.ToolButton =
                {
                    title: "อนุมัติ",
                    hint: "Approve",
                    separator: false,
                    cssClass: "bt-approve",
                    // icon: "fa fa-save",
                    // hotkey: 'alt+x',
                    onClick: (e) => {
                        // Q.confirm('ยืนยันการอนุมัติ', () => {
                            this.form.ApproveFg.value = ApproveFgonApptran.Posted.toString();
                            console.log(this.form.ApproveFg.value)
                            
                            this.save((response) => {
                                this.dialogClose();
                            });

                        // });
                    }
                };
                buttons.push(Approve);

                let reject: Serenity.ToolButton =
                {
                    title: "ยกเลิก",
                    hint: "Reject",
                    separator: false,
                    cssClass: "bt-reject",
                    // icon: "fa fa-save",
                    // hotkey: 'alt+x',
                    onClick: (e) => {
                        // Q.confirm('Reject เอกสารนี้', () => {
                            
                            this.form.ApproveFg.value = "2";
                            console.log(this.form.ApproveFg.value)

                            this.save((response) => {
                                this.dialogClose();
                            });

                        // });
                    }
                };
                buttons.push(reject);
                let Return: Serenity.ToolButton =
                {
                    title: "กลับไปแก้ไข",
                    hint: "Return",
                    separator: false,
                    cssClass: "bt-Return",
                    // icon: "fa fa-save",
                    // hotkey: 'alt+x',
                    onClick: (e) => {
                        // Q.confirm('Return เอกสารนี้', () => {
                            
                            this.form.ApproveFg.value = "3";
                            console.log(this.form.ApproveFg.value)

                            this.save((response) => {
                                this.dialogClose();
                            });

                        // });
                    }
                };
                buttons.push(Return);


            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );
            return buttons;




        }


        protected beforeLoadEntity(entity: PoApprovalTranRow): void {
            super.beforeLoadEntity(entity);
            console.log(entity)

            
            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 1 )
            console.log(app.SysFg)
            if (app.SysFg == 2) {//

                console.log(entity.SysDocNo  + "++" +entity.Level)
                let x = Q.tryFirst(PoApprovalTranRow.getLookup().items,x => x.SysDocNo == entity.SysDocNo && x.Level < entity.Level && x.ApproveFg <1 && x.AppActiveFg == 1 );
                console.log (x)
                if(x != null){
                    this.toolbar.findButton('bt-approve').hide();
                    this.toolbar.findButton('bt-reject').hide();
                    this.toolbar.findButton('bt-Return').hide();

                    Q.notifyError("ลำดับอนุมัติก่อนหน้ายังไม่ได้อนุมัติ");
                    setTimeout(() => {
                        this.dialogClose();
                    }, 0);
                   
                    
                }       
            } 

            var userId = Q.first(Administration.UserRow.getLookup().items, x => x.Username == Authorization.userDefinition.Username);
            var c = entity.ApprGroupCode
            var b = Q.tryFirst(Administration.UserApprovalRoleRow.getLookup().items, x => x.UserId == userId.UserId && x.ApprGroupCode == c);
            if(b != null){

            }else{
                // this.dialogClose();
                Q.notifyWarning("ไม่มีสิทธิ์อนุมัติในลำดับอนุมัตินี้");
                setTimeout(() => {
                    this.dialogClose();
                }, 0);
            }           

        }


        protected afterLoadEntity() {
            super.afterLoadEntity();



            // let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 1 )
            // console.log(app.SysFg)
            // if (app.SysFg == 2) {//

            //     console.log(this.entity.SysDocNo  + "++" +this.entity.Level)
            //     let x = Q.tryFirst(PoApprovalTranRow.getLookup().items,x => x.SysDocNo == this.entity.SysDocNo && x.Level < this.entity.Level && x.ApproveFg <1 && x.AppActiveFg == 1 );
            //     console.log (x)
            //     if(x != null){
            //         this.toolbar.findButton('bt-approve').hide();
            //         this.toolbar.findButton('bt-reject').hide();
            //         this.toolbar.findButton('bt-Return').hide();

            //         Q.alert("ลำดับอนุมัติก่อนหน้ายังไม่ได้อนุมัติ", {
            //             onClose: () => {
            //                 this.dialogClose();
            //             }
            //         });
                    
            //     }       
            // } 

            // var userId = Q.first(Administration.UserRow.getLookup().items, x => x.Username == Authorization.userDefinition.Username);
            // var c = this.entity.ApprGroupCode
            // var b = Q.tryFirst(Administration.UserApprovalRoleRow.getLookup().items, x => x.UserId == userId.UserId && x.ApprGroupCode == c);
            // if(b != null){

            // }else{
            //     Q.warning("ไม่มีสิทธิ์อนุมัติในลำดับอนุมัตินี้")
            //     this.dialogClose();
            // }           

             

            let x = this.entity.ApproveFg 
            if(x>0){
                this.toolbar.findButton('bt-approve').hide();
                this.toolbar.findButton('bt-reject').hide();
                this.toolbar.findButton('bt-Return').hide();
            }
              
        }

    }
}